import React from 'react';

import Input from './Input';

export const Textarea = React.forwardRef((props: any, ref: any) => (
  <Input {...props} as="textarea" textarea={true} ref={ref} />
));

export default Textarea;
